import MessengerAPI from "api/MessengerAPI";
import useFetchData from "hooks/useFetchData";

export default function useConversation( user_id?: number, page?: number ) {
    return useFetchData({
        APIMethod: MessengerAPI.getConversation,
        params: [ user_id, page ],
        condition: !!user_id
    })
}